import {Component, input} from '@angular/core';
import {Tooltip} from 'primeng/tooltip';

@Component({
  selector: 'elcia-tooltip',
  imports: [
    Tooltip
  ],
  templateUrl: './elcia-tooltip.component.html',
  styleUrl: './elcia-tooltip.component.scss',
})
export class ElciaTooltip {
  tooltip = input.required<string>();

}
